import { render, staticRenderFns } from "./ad-edit.vue?vue&type=template&id=4021d9fc&scoped=true&"
import script from "./ad-edit.vue?vue&type=script&lang=js&"
export * from "./ad-edit.vue?vue&type=script&lang=js&"
import style0 from "./ad-edit.vue?vue&type=style&index=0&id=4021d9fc&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=4021d9fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4021d9fc",
  null
  
)

component.options.__file = "ad-edit.vue"
export default component.exports